import {EvalData, VariantDef} from "./model";

export interface BenchmarkVariant {
    tab: string;
    lead: string;
    data: EvalData;
}

export function splitVariants(data: EvalData): BenchmarkVariant[] {
    const variants = data.variants || [];
    return variants.map(def => ({tab: def.tab, lead: def.lead, data: buildVariantData(data, def)}));
}

function buildVariantData(data: EvalData, def: VariantDef): EvalData {
    const groupIds = new Set(def.taskGroupIds);
    const excludeTags = new Set(def.excludeTags || []);
    const tasks = (data.tasks || []).filter(task => task.groupId != null && groupIds.has(task.groupId));
    const taskIds = tasks.map(task => task.id);
    const results = (data.results || [])
        .filter(model => !(model.tags || []).some(tag => excludeTags.has(tag)))
        .filter(model => taskIds.every(id => model.results?.[id] != null))
        .map(model => {
            const scores: any = {};
            for (const id of taskIds) scores[id] = model.results[id];
            return {...model, results: scores};
        });
    return {
        ...data,
        taskGroups: (data.taskGroups || []).filter(group => groupIds.has(group.id)),
        tasks: tasks,
        results: results,
        variants: undefined
    };
}
